import HeartColor from './HeartColour.svg';
import HeartDark from './HeartDark.svg';
import HeartLight from './HeartLight.svg';
export const heart = { color: HeartColor, dark: HeartDark, light: HeartLight };
//# sourceMappingURL=index.js.map